import { Container, Flex, Heading, ScrollArea, Spinner } from "@radix-ui/themes"
import ChatCardRender from "../../components/common/renders/chat-card-render"
import React, { useEffect, useRef, useState } from "react"
import { ArrowLeftIcon, ChatBubbleIcon } from "@radix-ui/react-icons"
import ChatRender from "../../components/common/renders/chat-render"
import { IMessage } from "../../core/types/services-types/messages-types"
import { useNavigate, useSearchParams} from 'react-router'
import WebsocketService from '../../core/services/WebsocketService'
import { IUser } from "../../core/types/services-types/user-types"
import useFetch from '../../core/hooks/useFetch'
import UserService from '../../core/services/UserService'
import MessageService from '../../core/services/MessageService'
import {ROUTES} from '../../routes/constants'
import {ToastContainer} from 'react-toastify'
export default function Chats() {

    const [searchParams, setSearchParams] = useSearchParams()

    const [chatId, setChatId] = useState<string | number | null>(searchParams.get('chat_id'))

    const [websocket, setWebsocket] = useState<WebsocketService>()

    const [message, setMessage] = useState<string>('')

    const [user, setUser] = useState<IUser>()

    const [messages, setMessages] = useState<IMessage[]>([])

    const [limitMessages, setLimitMessages] = useState<number>(100)

    const [pageMessages, setPageMessages] = useState<number>(0)

    const [totalMessages, setTotalMessages] = useState<number>(0)

    const [chats, setChats] = useState<IMessage[]>([])

    const [pageChats, setPageChats] = useState<number>(0)

    const [limitChats, setLimitChats] = useState<number>(100)

    const [totalChats, setTotalChats] = useState<number>(0)

    const refChats = useRef<HTMLDivElement>(null)

    const totalChatsRef = useRef(totalChats);

    const chatsRef = useRef(chats);

    

    const navigate = useNavigate()



    const [fetchUser, isLoadingUser, error, errors] = useFetch(async () => {
        console.log(chatId)
        if(chatId) {
        const data = await MessageService.GetAll(chatId, limitMessages, pageMessages)
        setMessages(data.data)
        setTotalMessages(data.count)
        if(data.data.length) {
        setUser(data.data[0].chat_companion)
        }
        else {
            const data = await UserService.Get(chatId)
            setUser(data)
        }
        }
        else {
            navigate(ROUTES.CHATS_ROUTE)
        }
    })

    const [fetchChats, isLoadingChats, errorChats, errorsChats] = useFetch(async () => {
        const data = await MessageService.GetAllUsersAndlastMessage(limitChats, pageChats)
        console.log(data)
        setChats(prev => [...prev, ...data.data]);
        setTotalChats(data.count)
        
    })

    const onClickCardChat = async (chat_id: string | number) => {
        console.log(chat_id)
        setChatId(chat_id)
        navigate(ROUTES.CHATS_ROUTE + '?chat_id=' + chat_id)
        
    }

    const [fetchCreateMessage, isLoadingSendingMessage, errorSendingMessage, errorsSendingMessage] = useFetch(async () => {
        if(chatId) {
        const data = await MessageService.Create(chatId, message)
        setMessages(prev => [...prev, data])
        const find = chats.find(chat => chat.chat_companion.id === data.chat_companion.id)
        if(!find) {
            setChats(prev => [...prev, data])
        }
        else {
            console.log('haveing')
            setChats(prev => prev.map(chat => {
                if(chat.id === find.id) {
                    chat = data
                }
                return chat
            }))
        }
        }
    })

    const sendMessage = async () => {
        if(message.length >= 1) {
        await fetchCreateMessage()
        setMessage('')
        }
    }

    const onBack = () => {
        console.log('navigate')
        setUser(undefined)
        setChatId(null)
        setMessages([])
        navigate(ROUTES.CHATS_ROUTE)
    }

  const loadChatsScroll = () => {
  if (
    totalChatsRef.current < chatsRef.current.length ||
    chatsRef.current.length <= 0
  ) {
    
    return;
  }

  setPageChats((prev) => prev + 1);
};
     
    useEffect(() => {
  totalChatsRef.current = totalChats;
}, [totalChats]);

useEffect(() => {
  chatsRef.current = chats;
}, [chats]);

    useEffect(() => {
        setWebsocket(new WebsocketService())
    }, [])

    useEffect(() => {
        if(chatId) {
        setMessages([])
        fetchUser()
        }
    }, [chatId])

    useEffect(() => {
      if(chatId) {
        fetchUser()
      }
    }, [pageMessages])

    useEffect(() => {
      fetchChats()
     
    }, [pageChats])

    useEffect(() => {
        if (!websocket?.socket) return;
      
        const handleMessage = (e: MessageEvent<any>) => {
          
          const parsedData = JSON.parse(e.data);
      
          if (parsedData.type === "new_message") {
             
            if (chatId) {
              
              if (Number(parsedData.message.sender_id) === Number(chatId)) {
                
                setMessages((prev) => [...prev, parsedData.message]);
              }
            }
      
            setChats((prev) => {
                const find = prev.find(chat => chat.chat_companion.id === parsedData.message.chat_companion.id)
              if(!find) {
             
                return [...prev, parsedData.message];
              }
              else {
               
                return prev.map(chat => {
                    if(chat.id === find.id) {
                      
                        chat = parsedData.message
                    }
                    return chat
                })
              }

            });
          }
        };
      

        websocket.socket.addEventListener("message", handleMessage);
      
        return () => {
          websocket.socket.removeEventListener("message", handleMessage);
        };
      }, [websocket?.socket]);


      useEffect(() => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                
               loadChatsScroll()
              }
            });
          },
          {
            root: null,  
            threshold: 1.0,  
          }
        );
    
        if (refChats.current) {
          observer.observe(refChats.current);
        }
    
        return () => {
          if (refChats.current) {
            observer.unobserve(refChats.current);
          }
        };
      }, []);


    return (
        <Container className="border md:p-5 pt-5 bg-zinc-100 min-h-[100vh]">
            <ToastContainer />
            <Flex className="chat-and-chats bg-zinc-50 shadow-xl rounded-lg p-5">

            <Container className={`border md:max-w-[400px] ${!chatId ? '!flex md:!flex' : '!hidden md:!flex'}`}> 
            <Heading className="p-5 flex items-center justify-center gap-2">
                
               <ChatBubbleIcon width={30} height={30} /> 
               Чаты
                </Heading>
                <hr />
            <ScrollArea type="always" scrollbars="vertical" style={{height: '630px'}}  className="chats border-top p-5">
                {isLoadingChats ? <Spinner />
                :
                <></>
}         
                {
                chats.map(chat => {
                    return <ChatCardRender 
                    data={chat} 
                    style={{border: 'none'}}
                    onClickCard={onClickCardChat}
                    />
                })
}
                <Container className="end-chats" ref={refChats}></Container>
            </ScrollArea>
            </Container>
            <Container className={`${!chatId ? '!hidden md:!flex' : '!flex md:!flex'} !shrink`}> 

                {
                !chatId || !user
                ?
                <Flex align={'center'} justify={'center'} minHeight={'600px'}>
                    <ArrowLeftIcon />
                    Выберите чат слева
                    </Flex>
                    :
                    isLoadingUser 
                    ? 
                    <Spinner />                     
                    :
                    <ChatRender 
                    data={user} 
                    messages={messages}
                    message={message}
                    setMessage={setMessage}
                    sendMessage={sendMessage}
                    onBack={onBack}
                    setPageMessages={setPageMessages}
                    totalMessages={totalMessages}
                    pageMessages={pageMessages}
                    isLoading={isLoadingUser}
                    />
                }
            
            </Container>
            
            </Flex>
        </Container>
    )
}